import { render, staticRenderFns } from "./GoodsPackageSingle.vue?vue&type=template&id=2bbdf098&scoped=true"
import script from "./GoodsPackageSingle.vue?vue&type=script&lang=ts"
export * from "./GoodsPackageSingle.vue?vue&type=script&lang=ts"
import style1 from "./GoodsPackageSingle.vue?vue&type=style&index=1&id=2bbdf098&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbdf098",
  null
  
)

export default component.exports